type MembersEmptyStateVariant = "none" | "search";

type MembersEmptyStateProps = {
  variant: MembersEmptyStateVariant;
};

const EMPTY_STATE_CONTENT: Record<
  MembersEmptyStateVariant,
  { title: string; subtitle: string; imageSrc: string }
> = {
  none: {
    title: "No members yet",
    subtitle:
      "Invite your team to start managing customers and handling operations",
    imageSrc: "/images/team-management/no-members.svg",
  },
  search: {
    title: "No members found",
    subtitle: "Try adjusting your search or filters.",
    imageSrc: "/images/team-management/no-members-found.svg",
  },
};

const MembersEmptyState = ({ variant }: MembersEmptyStateProps) => {
  const content = EMPTY_STATE_CONTENT[variant];

  return (
    <div className="grid min-h-[520px] place-items-center rounded-[16px] border-y border-[#EEF1FB] bg-white px-6 py-12">
      <div className="flex max-w-[360px] flex-col items-center text-center">
        <img
          src={content.imageSrc}
          alt={content.title}
          className="h-[180px] w-[180px] object-contain"
        />
        <h3 className="text-[24px] font-[500] text-[#161827]">
          {content.title}
        </h3>
        <p className="text-[16px] leading-7 text-[#6B6F8A]">
          {content.subtitle}
        </p>
      </div>
    </div>
  );
};

export default MembersEmptyState;
